import defaultFields from 'store/KnowledgeBase/fields';
import { updatePreferences } from 'store/Preferences/actions';
import { selectFields } from './selectors';
import { cloneDeep } from 'lodash';

export function setFieldVisibility (field, value) {
  return async (dispatch, getState) => {
    let kb_table = cloneDeep(selectFields(getState()));

    if (!kb_table) kb_table = { ...defaultFields };
    if (!kb_table[field].locked) {
      kb_table[field].visible = value;

      if (value) kb_table[field].order = Object.keys(kb_table).filter((key) => kb_table[key].visible).length;
      else {
        let cont = 1;
        Object.keys(kb_table)
          .filter(f => kb_table[f].visible && f !== field)
          .sort((a, b) => (kb_table[a].order - kb_table[b].order))
          .forEach(f2 => {
            kb_table[f2].order = cont;
            cont++;
          });
      }

      dispatch(updatePreferences({ kb_table }));
    }
  };
}

export function setFieldWidth (field, value) {
  return async (dispatch, getState) => {
    const kb_table = cloneDeep(selectFields(getState()));
    if (kb_table[field]) {
      kb_table[field].maxWidth = value;
      kb_table[field].minWidth = value;
      dispatch(updatePreferences({ kb_table }));
    }
  };
}

export function setNewOrderColumns (columns) {
  return async (dispatch, getState) => {
    let kb_table = cloneDeep(selectFields(getState()));
    if (!kb_table) kb_table = { ...defaultFields };

    const fixedColumnsCount = Object.values(kb_table).filter(col => col.locked).length;

    columns.forEach((column, index) => {
      if (column && !kb_table[column].locked) {
        kb_table[column].order = index + 1 + fixedColumnsCount;
      }
    });

    dispatch(updatePreferences({ kb_table }));
  };
}

export function resetDefault () {
  return async (dispatch) => {
    dispatch(updatePreferences({ kb_table: defaultFields }));
  };
}
